import axios from "axios";
import SideNavbar from "../../../components/common/SideNavbar";
import TopNavbar from "../../../components/common/TopNavbar";
import { useEffect, useState } from "react";
import { Button, Spinner, Modal } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { userTableCustomStyles } from "../../../utils/TableCustomStyles";

function MessageMaster() {
  const [menuDrawerShow, setMenuDrawerShow] = useState(true);
  const [data, setData] = useState([]);
  const [dataPending, setDataPending] = useState(true);
  const [currentUserRolePermissionData, setCurrentUserRolePermissionData] =
    useState([]);
  const [dataFromTopNavBar, setDataFromTopNavBar] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const user_role = sessionStorage["userrole"];
  const user_id = sessionStorage["id"];
  const [loggedInUser, setLoggedInUser] = useState(null);

  // Canvas visibility
  const [showAddCanvas, setShowAddCanvas] = useState(false);
  const [showUpdateCanvas, setShowUpdateCanvas] = useState(false);
  const [canvasAddFullScreen, setCanvasAddFullScreen] = useState(false);
  const [canvasUpdateFullScreen, setCanvasUpdateFullScreen] = useState(false);

  // Loaders
  const [showAddLoader, setShowAddLoader] = useState(false);
  const [showUpdateLoader, setShowUpdateLoader] = useState(false);
  const [showDeleteLoader, setShowDeleteLoader] = useState(false);

  const [recordForDelete, setRecordForDelete] = useState(null);

  // ---------- Add form state ----------
  const [addMessage, setAddMessage] = useState("");
  const [addMessageType, setAddMessageType] = useState("AGENT");
  const [addStatus, setAddStatus] = useState("UNREAD");

  // Add field errors (only message is required)
  const [showMessageError, setShowMessageError] = useState(false);

  // Add validation summary
  const [showValidationError, setShowValidationError] = useState(false);
  const [validationErrorArray, setValidationErrorArray] = useState([]);
  const [isValidationErrorVisible, setIsValidationErrorVisible] =
    useState(false);

  // ---------- Update form state ----------
  const [updateId, setUpdateId] = useState("");
  const [updateMessage, setUpdateMessage] = useState("");
  const [updateMessageType, setUpdateMessageType] = useState("");
  const [updateStatus, setUpdateStatus] = useState("");

  // Update field errors
  const [showUpdateMessageError, setShowUpdateMessageError] = useState(false);

  // Update validation summary
  const [showUpdateValidationError, setShowUpdateValidationError] =
    useState(false);
  const [updateValidationErrorArray, setUpdateValidationErrorArray] = useState(
    [],
  );
  const [isUpdateValidationErrorVisible, setIsUpdateValidationErrorVisible] =
    useState(false);

  // ========== Real‑time error helpers ==========
  const hasAnyAddError = () => showMessageError;

  const buildAddErrorMessages = () => {
    const errors = [];
    if (!addMessage) errors.push("Message is required");
    return errors;
  };

  const hasAnyUpdateError = () => showUpdateMessageError;

  const buildUpdateErrorMessages = () => {
    const errors = [];
    if (!updateMessage) errors.push("Message is required");
    return errors;
  };

  // Tooltip toggles
  const handleCheckValidationClick = () =>
    setIsValidationErrorVisible(!isValidationErrorVisible);
  const handleUpdateCheckValidationClick = () =>
    setIsUpdateValidationErrorVisible(!isUpdateValidationErrorVisible);

  // ========== API calls ==========
  const getLoggedInUser = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/user/user/" + user_id,
      );
      setLoggedInUser(response.data);
    } catch (err) {
      toast.error("Error in fetching user data! Try again.");
    }
  };

  const getMessage = async () => {
    try {
      setDataPending(true);
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/master/message/",
      );
      setData(response.data);
    } catch (err) {
      toast.error("Error in fetching message data! Try again.");
    } finally {
      setDataPending(false);
    }
  };

  const getCurrentUserRolePermission = async (roles) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL +
          "/user/role/getuserrolepermission?roles=" +
          roles,
      );
      const role_permissions_array = [];
      for (let i = 0; i < response.data?.length; i++) {
        for (let j = 0; j < response?.data[i]?.permissions_array?.length; j++) {
          if (
            !role_permissions_array.includes(
              response?.data[i]?.permissions_array?.[j],
            )
          ) {
            role_permissions_array.push(
              response?.data[i]?.permissions_array?.[j],
            );
          }
        }
      }
      setCurrentUserRolePermissionData(role_permissions_array);
    } catch (err) {
      toast.error("Error in fetching user role data! Try again.");
    }
  };

  useEffect(() => {
    getLoggedInUser();
    getMessage();
  }, []);

  useEffect(() => {
    getCurrentUserRolePermission(user_role);
  }, [user_role]);

  // ========== Delete handlers ==========
  const handleDeleteModalClose = () => setShowDeleteModal(false);
  const handleDeleteModalOpen = (data) => {
    setShowDeleteModal(true);
    setRecordForDelete(data);
  };

  const deleteSelectedRecord = async (id) => {
    setShowDeleteLoader(true);
    try {
      await axios.delete(
        process.env.REACT_APP_BACKEND_API_URL + "/master/message/" + id + "/",
      );
      setShowDeleteModal(false);
      getMessage();
      toast.success("Record deleted successfully");
    } catch (err) {
      toast.error("Error in deleting record! Try again.");
    }
    setShowDeleteLoader(false);
  };

  // ========== Add logic ==========
  const resetAddForm = () => {
    setAddMessage("");
    setAddMessageType("AGENT");
    setAddStatus("UNREAD");
    setShowMessageError(false);
    setShowValidationError(false);
    setValidationErrorArray([]);
    setIsValidationErrorVisible(false);
  };

  const handleAddModalClose = () => {
    resetAddForm();
    setShowAddCanvas(false);
    setCanvasAddFullScreen(false);
  };

  const addNewMessage = async (e) => {
    e.preventDefault();

    setShowMessageError(!addMessage);
    setValidationErrorArray(buildAddErrorMessages());

    if (!addMessage) {
      setShowValidationError(true);
      return;
    }

    setShowAddLoader(true);

    const payload = {
      message: addMessage,
      message_type: addMessageType,
      status: addStatus,
      created_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type}),
    };

    try {
      const response = await axios.post(
        process.env.REACT_APP_BACKEND_API_URL + "/master/message/",
        payload,
        { headers: { "content-type": "application/json" } },
      );
      if (response.status === 200 || response.status === 201) {
        toast.success("Message Created Successfully");
        handleAddModalClose();
        getMessage();
      }
    } catch (err) {
      toast.error("Error creating message");
    } finally {
      setShowAddLoader(false);
    }
  };

  // ========== Update logic ==========
  const resetUpdateForm = () => {
    setUpdateId("");
    setUpdateMessage("");
    setUpdateMessageType("");
    setUpdateStatus("");
    setShowUpdateMessageError(false);
    setShowUpdateValidationError(false);
    setUpdateValidationErrorArray([]);
    setIsUpdateValidationErrorVisible(false);
  };

  const handleUpdateModalClose = () => {
    resetUpdateForm();
    setShowUpdateCanvas(false);
    setCanvasUpdateFullScreen(false);
  };

  const handleSetUpdateData = (row) => {
    setUpdateId(row.id);
    setUpdateMessage(row.message);
    setUpdateMessageType(row.message_type);
    setUpdateStatus(row.status);
    // Reset errors
    setShowUpdateMessageError(false);
    setShowUpdateValidationError(false);
    setUpdateValidationErrorArray([]);
  };

  const updateMessageData = async (e) => {
    e.preventDefault();

    setShowUpdateMessageError(!updateMessage);
    setUpdateValidationErrorArray(buildUpdateErrorMessages());

    if (!updateMessage) {
      setShowUpdateValidationError(true);
      return;
    }

    setShowUpdateLoader(true);

    const payload = {
      message: updateMessage,
      message_type: updateMessageType,
      status: updateStatus,
      modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type}),
    };

    try {
      const response = await axios.put(
        process.env.REACT_APP_BACKEND_API_URL +
          "/master/message/" +
          updateId +
          "/",
        payload,
        { headers: { "content-type": "application/json" } },
      );
      if (response.status === 200 || response.status === 201) {
        toast.success("Message Updated Successfully");
        handleUpdateModalClose();
        getMessage();
      }
    } catch (err) {
      toast.error("Error updating message");
    } finally {
      setShowUpdateLoader(false);
    }
  };

  // ========== Table columns ==========
  const columns = [
    { name: "Message", selector: (row) => row.message, sortable: true },
    { name: "Type", selector: (row) => row.message_type, sortable: true },
    { name: "Status", selector: (row) => row.status, sortable: true },
    {
      name: "Action",
      center: true,
      selector: (row) => (
        <div>
          {currentUserRolePermissionData?.includes("master:task:update") ? (
            <Button
              className="btn btn-sm btn-inox-green border-0"
              title="Update"
              onClick={() => {
                handleSetUpdateData(row);
                setShowUpdateCanvas(true);
              }}
            >
              <i className="fa fa-edit"></i>
            </Button>
          ) : (
            ""
          )}
          {currentUserRolePermissionData?.includes("master:task:delete") ? (
            <Button
              className="btn btn-sm bg-danger border-0 mx-2"
              title="Delete"
              onClick={() => handleDeleteModalOpen(row)}
            >
              <i className="fa fa-trash"></i>
            </Button>
          ) : (
            ""
          )}
        </div>
      ),
    },
  ];

  const handleDataFromTopNavBar = (permissiondata) =>
    setDataFromTopNavBar(permissiondata);

  return (
    <div className="page-content-bg">
      <ToastContainer />
      <TopNavbar
        sidebarCollapsed={menuDrawerShow}
        topNavbarStatic={true}
        sendDataToParent={handleDataFromTopNavBar}
      />
      <SideNavbar
        sidebarCollapsed={menuDrawerShow}
        activeMenu="Master"
        activeSubMenu="AdminMaster"
        activeSubMenuLevel1="MessageMaster"
        permissionFromTopNavbar={dataFromTopNavBar}
      />

      <div
        className={
          menuDrawerShow
            ? "row main-content-collapsed text-left py-0"
            : "row main-content text-left py-0"
        }
      >
        <div className="col-12 page-header">
          <div className="row">
            <div className="col-6 py-1">
              <Button
                className="btn btn-sm btn-inox-green border-0 mx-2"
                onClick={() => setMenuDrawerShow(!menuDrawerShow)}
              >
                {menuDrawerShow ? (
                  <span>
                    <i className="fa fa-chevron-left mx-1"></i>
                  </span>
                ) : (
                  <span>
                    <i className="fa fa-chevron-right mx-1"></i>
                  </span>
                )}
              </Button>
              <span className="page-header-text">Message Master</span>
            </div>
            <div className="col-6 py-1" style={{ paddingRight: 30 }}>
              {currentUserRolePermissionData?.includes(
                "master:customer:add",
              ) ? (
                <Button
                  className="btn btn-sm btn-inox-green border-0 px-3 float-right"
                  onClick={() => {
                    resetAddForm();
                    setShowAddCanvas(true);
                  }}
                >
                  <i
                    className="fa fa-plus fa-lg text-right"
                    style={{ paddingRight: 10 }}
                  ></i>
                  <span className="fw-bold">Add Message</span>
                </Button>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>

        <div
          className="col-12 text-left"
          style={{
            marginTop: -5,
            paddingLeft: 20,
            paddingRight: 30,
            zIndex: 100,
          }}
        >
          <DataTable
            columns={columns}
            data={data}
            progressPending={dataPending}
            progressComponent={
              <Spinner
                className="mx-5 text-inox-green table-spinner"
                as="span"
                animation="border"
                size="lg"
                role="status"
                aria-hidden="true"
              />
            }
            noDataComponent={
              <p className="text-center table-no-data">No Data Found</p>
            }
            pagination
            highlightOnHover
            fixedHeader
            customStyles={userTableCustomStyles}
            dense
          />
        </div>
      </div>

      {/* Delete Modal */}
      <Modal
        size="sm"
        show={showDeleteModal}
        onHide={handleDeleteModalClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you want to delete this record?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleDeleteModalClose}>
            Close
          </Button>
          <Button
            variant="danger"
            onClick={() => deleteSelectedRecord(recordForDelete?.id)}
          >
            {showDeleteLoader ? (
              <Spinner
                className="mx-3 text-white"
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              "Delete"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ------------------------ Update Canvas ------------------- */}
      <div
        className={
          canvasUpdateFullScreen && showUpdateCanvas
            ? "offcanvas offcanvas-bottom h-100 show"
            : !canvasUpdateFullScreen && showUpdateCanvas
              ? "offcanvas offcanvas-bottom h-50 show"
              : "offcanvas offcanvas-bottom h-50"
        }
        tabIndex="-1"
        aria-labelledby="updateCanvasLabel"
      >
        <div className="offcanvas-header w-100">
          <div className="row w-100">
            <div className="col-6">
              <h4 id="updateCanvasLabel" className="float-left">
                Update Record
              </h4>
            </div>
            <div className="col-6">
              <button
                type="button"
                className="btn btn-danger btn-sm float-right"
                aria-label="Close"
                title="Close"
                onClick={handleUpdateModalClose}
              >
                <i className="fa fa-times text-white"></i>
              </button>
              {canvasUpdateFullScreen ? (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Half Screen"
                  onClick={() => setCanvasUpdateFullScreen(false)}
                >
                  <i className="fa fa-window-minimize text-white"></i>
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Full Screen"
                  onClick={() => setCanvasUpdateFullScreen(true)}
                >
                  <i className="fa fa-window-maximize text-white"></i>
                </button>
              )}
            </div>
          </div>
        </div>

        <div
          className="offcanvas-body"
          style={{ paddingLeft: 20, paddingRight: 40 }}
        >
          <form onSubmit={updateMessageData}>
            <div className="row">
              {/* Message */}
              <div
                className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="update_message">
                  Message:
                  <span className="text-danger">
                    {showUpdateMessageError ? " Message required" : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="update_message"
                  placeholder="Enter Message"
                  value={updateMessage}
                  onChange={(e) => {
                    setUpdateMessage(e.target.value);
                    setShowUpdateMessageError(false);
                    setShowUpdateValidationError(false);
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowUpdateMessageError(e.target.value === "");
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                />
              </div>

              {/* Message Type */}
              <div
                className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label htmlFor="update_message_type">Type:</label>
                <select
                  className="form-select form-select-sm"
                  id="update_message_type"
                  value={updateMessageType}
                  onChange={(e) => setUpdateMessageType(e.target.value)}
                >
                  <option value="AGENT">AGENT</option>
                  <option value="DEPOT">DEPOT</option>
                </select>
              </div>

              {/* Status */}
              <div
                className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label htmlFor="update_status">Status:</label>
                <select
                  className="form-select form-select-sm"
                  id="update_status"
                  value={updateStatus}
                  onChange={(e) => setUpdateStatus(e.target.value)}
                >
                  <option value="READ">READ</option>
                  <option value="UNREAD">UNREAD</option>
                </select>
              </div>

              {/* Submit Button + Error Tooltip */}
              <div
                className={`form-group ${canvasUpdateFullScreen ? "col-md-12" : "col-md-12"}`}
              >
                <div className="canvas-btn-row">
                  <Button
                    type="submit"
                    className="btn btn-inox-green border-0 canvas-button"
                    disabled={hasAnyUpdateError() || showUpdateLoader}
                  >
                    {showUpdateLoader ? (
                      <Spinner
                        className="mx-4"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      <>
                        <i className="fa fa-edit"></i>{" "}
                        <span className="mx-2">Update</span>
                      </>
                    )}
                  </Button>

                  {(hasAnyUpdateError() || showUpdateValidationError) && (
                    <div className="error-tooltip-wrapper">
                      <Button
                        style={{
                          backgroundColor: "#C21E22",
                          border: "#f82e2e",
                        }}
                        title="Show Errors"
                        className="mx-2"
                        onClick={handleUpdateCheckValidationClick}
                        onMouseLeave={() =>
                          setIsUpdateValidationErrorVisible(false)
                        }
                      >
                        <i className="fa fa-exclamation"></i>
                      </Button>
                      {isUpdateValidationErrorVisible && (
                        <div className="validation-error-tooltip">
                          <ul className="mb-0 px-4">
                            {updateValidationErrorArray.map((error, index) => (
                              <li key={index} className="text-left small pb-0">
                                {error}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      {/* ------------------------ Add Canvas ------------------- */}
      <div
        className={
          canvasAddFullScreen && showAddCanvas
            ? "offcanvas offcanvas-bottom h-100 show"
            : !canvasAddFullScreen && showAddCanvas
              ? "offcanvas offcanvas-bottom h-50 show"
              : "offcanvas offcanvas-bottom h-50"
        }
        tabIndex="-1"
        aria-labelledby="addCanvasLabel"
      >
        <div className="offcanvas-header w-100">
          <div className="row w-100">
            <div className="col-6">
              <h4 id="addCanvasLabel" className="float-left">
                Add New Record
              </h4>
            </div>
            <div className="col-6">
              <button
                type="button"
                className="btn btn-danger btn-sm float-right"
                aria-label="Close"
                title="Close"
                onClick={handleAddModalClose}
              >
                <i className="fa fa-times text-white"></i>
              </button>
              {canvasAddFullScreen ? (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Half Screen"
                  onClick={() => setCanvasAddFullScreen(false)}
                >
                  <i className="fa fa-window-minimize text-white"></i>
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Full Screen"
                  onClick={() => setCanvasAddFullScreen(true)}
                >
                  <i className="fa fa-window-maximize text-white"></i>
                </button>
              )}
            </div>
          </div>
        </div>

        <div
          className="offcanvas-body"
          style={{ paddingLeft: 20, paddingRight: 40 }}
        >
          <form onSubmit={addNewMessage}>
            <div className="row">
              {/* Message */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="add_message">
                  Message:
                  <span className="text-danger">
                    {showMessageError ? " Message required" : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="add_message"
                  placeholder="Enter Message"
                  value={addMessage}
                  onChange={(e) => {
                    setAddMessage(e.target.value);
                    setShowMessageError(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowMessageError(e.target.value === "");
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                />
              </div>

              {/* Message Type */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label htmlFor="add_message_type">Type:</label>
                <select
                  className="form-select form-select-sm"
                  id="add_message_type"
                  value={addMessageType}
                  onChange={(e) => setAddMessageType(e.target.value)}
                >
                  <option value="AGENT">AGENT</option>
                  <option value="DEPOT">DEPOT</option>
                </select>
              </div>

              {/* Status */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label htmlFor="add_status">Status:</label>
                <select
                  className="form-select form-select-sm"
                  id="add_status"
                  value={addStatus}
                  onChange={(e) => setAddStatus(e.target.value)}
                >
                  <option value="READ">READ</option>
                  <option value="UNREAD">UNREAD</option>
                </select>
              </div>

              {/* Submit Button + Error Tooltip */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-12" : "col-md-12"}`}
              >
                <div className="canvas-btn-row">
                  <Button
                    type="submit"
                    className="btn btn-inox-green border-0 canvas-button"
                    disabled={hasAnyAddError() || showAddLoader}
                  >
                    {showAddLoader ? (
                      <Spinner
                        className="mx-4"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      <>
                        <i className="fa fa-plus"></i>{" "}
                        <span className="mx-2">Add</span>
                      </>
                    )}
                  </Button>

                  {(hasAnyAddError() || showValidationError) && (
                    <div className="error-tooltip-wrapper">
                      <Button
                        style={{
                          backgroundColor: "#C21E22",
                          border: "#f82e2e",
                        }}
                        title="Show Errors"
                        className="mx-2"
                        onClick={handleCheckValidationClick}
                        onMouseLeave={() => setIsValidationErrorVisible(false)}
                      >
                        <i className="fa fa-exclamation"></i>
                      </Button>
                      {isValidationErrorVisible && (
                        <div className="validation-error-tooltip">
                          <ul className="mb-0 px-4">
                            {validationErrorArray.map((error, index) => (
                              <li key={index} className="text-left small pb-0">
                                {error}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default MessageMaster;
